import React, { useEffect, useState } from 'react';
import { Grow, Popover } from '@mui/material';
import { MinLoader, TextToolTip, ToastScreen } from '../../../components';
import { AddPayoutDate } from './addPayoutDate';
import { FindError, FindErrorItem, FindLoad, FindSuccess, Images, usePrimaryModal } from 'utils';
import { useDispatch } from 'react-redux';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, loadActions } from '../../../store';
import { ACTION_TYPE_MOVE_BATCH, ACTION_TYPE_REMOVE_BATCH, settings } from './constants';
import { toast } from 'react-toastify';


export const SettingsPendingPayBatchesDetails = (
  {
    batch, batchesList = [], load, afterMoveSuccess = () => {
  },
  }) => {
  const [currentItem, setCurrentItem] = useState(null);
  const [currentBatchItemId, setCurrentBatchItemId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const { openPrimary, closePrimary } = usePrimaryModal();
  const loading = FindLoad(ACTION_TYPE_MOVE_BATCH);
  const success = FindSuccess(ACTION_TYPE_MOVE_BATCH);
  const loadingRemove = FindLoad(ACTION_TYPE_REMOVE_BATCH);
  const successRemove = FindSuccess(ACTION_TYPE_REMOVE_BATCH);
  const beckError = FindErrorItem(ACTION_TYPE_MOVE_BATCH);
  const beckRemove = FindError(ACTION_TYPE_REMOVE_BATCH);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    if (beckError?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_MOVE_BATCH));

      toast(
        <ToastScreen
          type={'error'}
          text={beckError?.[0]?.error}
        />,
      );
    }

    if (beckRemove?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_REMOVE_BATCH));

      toast(
        <ToastScreen
          type={'error'}
          text={beckRemove?.[0]?.error}
        />,
      );
    }
  }, [beckError?.[0]?.error, beckRemove?.[0]?.error]);


  useEffect(() => {
    if (success?.length || successRemove?.length) {
      if (success?.length) dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_MOVE_BATCH));
      if (loadingRemove?.length) dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_REMOVE_BATCH));

      setCurrentItem(null);
      setCurrentBatchItemId(null);
      setAnchorEl(null);
      afterMoveSuccess();
    }
  }, [success]);

  const toggleMenu = (event) => {
    if (event) {
      setAnchorEl(event?.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  const handleClick = (id) => {
    setCurrentItem(id);
    if (id === 2) {
      openPrimary(
        <AddPayoutDate
          handleClose={closePrimary}
          fromBatch={batch}
          selectedLoads={load?.id ? [load] : ''}
        />,
      );
      setAnchorEl(null);
    }
    if (id === 3) {
      const body = {
        loadIds: [load?.id],
      };
      dispatch(loadActions.removeLoadsPayableBatches(batch, body));
    }
  };

  const handleClickMoveToItem = (id) => {
    setCurrentBatchItemId(id);
  };


  const handleSave = () => {
    const body = {
      loadIds: [load?.id],
      fromBatchId: batch,
    };
    dispatch(loadActions.moveLoadsPayableBatches(currentBatchItemId, body));
  };


  return (
    <div className='settings-pending-pay-batches-details-wrapper'>
      <div className='settings-pending-pay-batches-details-icon' onClick={toggleMenu}>
        <img src={Images.settings2} alt='settings' />
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => toggleMenu()}
        TransitionComponent={Grow}
        TransitionProps={{
          onExited: () => {
            setCurrentItem(null);
            setCurrentBatchItemId(null);
          },
        }}
        className={
          currentItem === 1
            ? 'settings-pending-pay-batches-move-to-box'
            : 'settings-pending-pay-batches-details-box'
        }
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {currentItem === 1 ? (
          <div>
            <div className='settings-pending-pay-batches-details-move-to-header'>
              <div className='flex-align-center' style={{ justifyContent: 'space-between' }}>

                <div className='flex-align-center' style={{ gap: 10 }}>
                  <button
                    className='details-move-to-button'
                    onClick={() => {
                      setCurrentItem(null);
                      setCurrentBatchItemId(null);
                    }}
                  >
                    <img src={Images.arrowLeft2} alt='arrow' />
                  </button>

                  <p className='details-move-to-text'>
                    Move to
                  </p>
                </div>

                <button
                  className='details-move-to-save-button'
                  disabled={!currentBatchItemId}
                  style={{ opacity: !currentBatchItemId ? .7 : 1 }}
                  onClick={handleSave}
                >
                  {loading?.length ?
                    <MinLoader style={{ position: 'static', color: '#43BA4D', margin: '0' }} />
                    :
                    'Save'
                  }

                </button>
              </div>
            </div>
            <div className='settings-pending-pay-batches-details-move-to-item-wrapper'>
              {batchesList.map(({ name, id }) => (
                <div
                  key={id}
                  className={`settings-pending-pay-batches-move-to-details-item-box ${currentBatchItemId === id ? 'active-move-to-item' : ''}`}
                  onClick={() => handleClickMoveToItem(id)}
                >
                  <TextToolTip
                    text={name}
                    content={name}
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className='settings-pending-pay-batches-details-item-wrapper'>
            {settings.map(({ Image, text, id }) => (
              <div
                key={id}
                className='settings-pending-pay-batches-details-item-box'
                onClick={() => handleClick(id)}
              >
                <div className='settings-pending-pay-batches-details-item_img'>
                  {(loadingRemove?.length && currentItem === id) ?
                    <MinLoader style={{ position: 'static', color: '#51566D', margin: '0' }} />
                    :
                    <img src={Image} alt='arrow' />
                  }
                </div>
                <p className='settings-pending-pay-batches-details-item-text'>{text}</p>
              </div>
            ))}
          </div>
        )}
      </Popover>
    </div>
  );
};

